import type { RouteRecordRaw } from "vue-router";

export const intRoutes: RouteRecordRaw[] = [
  {
    path: "/int/partners",
    component: () => import("./IntPartnerLayout.vue"),
    meta: {
      international: true,
    },
    children: [
      {
        path: "",
        name: "international-partners-index",
        component: () => import("./partners/IntPartnerListPage.vue"),
      },
      {
        path: ":id-:slug",
        name: "international-partners-show",
        component: () => import("./partners/IntPartnerDetailPage.vue"),
      },
    ],
  },
];
